import * as React from "react";
import { SVGProps } from "react";
const SvgPhone = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m26.989 21.053-2.479-2.479a1.743 1.743 0 0 0-2.465 0l-1.778 1.783-.516-.224a27.098 27.098 0 0 1-1.777-.874c-1.082-.583-2.272-1.34-3.06-2.13-.83-.826-1.628-2.102-2.232-3.234l-.16-.304c-.267-.515-.49-.987-.657-1.357l-.221-.5 1.782-1.778a1.736 1.736 0 0 0 0-2.465l-2.478-2.479a1.74 1.74 0 0 0-2.465 0l-3.64 3.641c-.291.304-.337.669-.343 1.048.003.66.202 1.487.532 2.455.999 2.885 3.21 6.928 5.52 9.25 1.549 1.545 3.874 3.044 6.112 4.179 1.028.529 2.09.988 3.18 1.375.972.334 1.802.536 2.463.539.376-.006.739-.053 1.04-.34l3.642-3.641a1.743 1.743 0 0 0 0-2.465Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPhone;
